import styled from 'styled-components';

//helpers
import {transparentize} from 'utils/color-utils';
import {scrollbarWidth} from 'utils/dom-utils';

const getColorStops = color => `
  ${transparentize(color, 0)},
  ${color}
`;

export const FadingOverlay = styled.div.attrs({
  className: 'has-reached-bottom has-reached-top should-animate'
})`
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: ${p => (p.isScrollable ? scrollbarWidth : 0)}px;
  top: 0;
  transform: translateZ(0); // force 3d rendering so it won't flicker on iOS

  &::before,
  &::after {
    content: '';
    left: 0;
    position: absolute;
    width: 100%;
  }

  &::before {
    background: linear-gradient(to top, ${p => getColorStops(p.color)});
    height: 20%;
    top: -1px;
  }

  &::after {
    background: linear-gradient(to bottom, ${p => getColorStops(p.color)});
    bottom: -1px;
    height: 20%;
  }

  &.has-reached-top::before,
  &.has-reached-bottom::after {
    opacity: 0;
  }

  &.should-animate::before,
  &.should-animate::after {
    transition: 0.2s opacity ease-out;
  }
`;

export const OffsetParent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;

export const InnerWrapper = styled.div.attrs({
  className: 'FadingOverlay__InnerWrapper'
})`
  max-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;

  ${p =>
    p.isScrollable &&
    `
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
  `}
`;
